export default "__VITE_ASSET__46a7d228__"